function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Row, Container, Col, Table } from 'react-bootstrap';
import { Flex, Radio, Skeleton, message, Button, DatePicker, Input, Select, Modal, Tabs, Drawer, Descriptions, Result, Statistic, notification, Space, Form, Popover } from 'antd';
import moment from "moment";
import Common from "../components/includes/Common";
import { Icon } from "@iconify/react";
import { PrinterFill, FileCheckFill, XLg, ThreeDots, PersonVcardFill, PersonPlusFill, ClockHistory, Plus, PencilFill } from 'react-bootstrap-icons';
import PatientView from "../components/PatientView";
import EditCandidate from "../components/forms/EditCandidate";
import Moment from "react-moment";
import AddIdFile from "../components/forms/AddIdFile";
import AddCustomer from "../components/forms/AddCustomer";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Search = Input.Search;
var RangePicker = DatePicker.RangePicker;
var Cashier = function Cashier() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCustomer = _useState2[0],
    setSelectedCustomer = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    dataChanged = _useState4[0],
    setDataChanged = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isDataLoading = _useState6[0],
    setIsDataLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    customers = _useState8[0],
    setCustomers = _useState8[1];
  var _useState9 = useState([{
      value: 0,
      label: "TOUTES"
    }]),
    _useState0 = _slicedToArray(_useState9, 2),
    compOptions = _useState0[0],
    setCompOptions = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    execDrawerVisible = _useState10[0],
    setExecDrawerVisible = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    newCustomerCreated = _useState12[0],
    setNewCustomerCreated = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isPatientModalOpen = _useState14[0],
    setIsPatientModalOpen = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    searchId = _useState16[0],
    setSearchId = _useState16[1];
  var _useState17 = useState(0),
    _useState18 = _slicedToArray(_useState17, 2),
    totalCash = _useState18[0],
    setTotalCash = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showEdit = _useState20[0],
    setShowEdit = _useState20[1];
  var _useState21 = useState(null),
    _useState22 = _slicedToArray(_useState21, 2),
    currentCustomer = _useState22[0],
    setCurrentCustomer = _useState22[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    showNewCandidate = _useState24[0],
    setShowNewCandidate = _useState24[1];
  var _useState25 = useState(moment().startOf('week').format()),
    _useState26 = _slicedToArray(_useState25, 2),
    from = _useState26[0],
    setFrom = _useState26[1];
  var _useState27 = useState(moment().endOf('week').format()),
    _useState28 = _slicedToArray(_useState27, 2),
    to = _useState28[0],
    setTo = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    keyStats = _useState30[0],
    setKeyStats = _useState30[1];
  var _useState31 = useState(false),
    _useState32 = _slicedToArray(_useState31, 2),
    open = _useState32[0],
    setOpen = _useState32[1];
  var _useState33 = useState(null),
    _useState34 = _slicedToArray(_useState33, 2),
    exCandidateCode = _useState34[0],
    setExCandidateCode = _useState34[1];
  var _useState35 = useState(null),
    _useState36 = _slicedToArray(_useState35, 2),
    exCandidate = _useState36[0],
    setExCandidate = _useState36[1];
  var _useState37 = useState(false),
    _useState38 = _slicedToArray(_useState37, 2),
    exSearchLoading = _useState38[0],
    setExSearchLoading = _useState38[1];
  var _useState39 = useState(false),
    _useState40 = _slicedToArray(_useState39, 2),
    redirectLoading = _useState40[0],
    setRedirectLoading = _useState40[1];
  var _useState41 = useState(0),
    _useState42 = _slicedToArray(_useState41, 2),
    exOrientation = _useState42[0],
    setExOrientation = _useState42[1];
  var _useState43 = useState(false),
    _useState44 = _slicedToArray(_useState43, 2),
    showHistory = _useState44[0],
    setShowHistory = _useState44[1];
  var _useState45 = useState(false),
    _useState46 = _slicedToArray(_useState45, 2),
    showAddFile = _useState46[0],
    setShowAddFile = _useState46[1];
  var handleUpdate = function handleUpdate() {
    setShowNewCandidate(false);
    notification.success({
      message: "Ok!",
      description: "Opération réussie"
    });
    setNewCustomerCreated(true);
    setDataChanged(true);
  };
  var handleOpenChange = function handleOpenChange(newOpen) {
    setOpen(newOpen);
  };
  var handleExCodeChange = function handleExCodeChange(v) {
    setExCandidateCode(v.target.value);
  };
  var handleGetEx = function handleGetEx() {
    setExSearchLoading(true);
    axios.post(Common.baseApiUrl + "getcustomerfromcode", {
      candidate_code: exCandidateCode,
      user_id: Common.currentUser.id
    }).then(function (response) {
      if (response.data.status == 200) {
        setExCandidate(response.data.customer);
        setExecDrawerVisible(true);
      } else {
        notification.error({
          message: "Erreur !",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur !",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setExSearchLoading(false);
    });
  };
  var onSearchFinish = function onSearchFinish(values) {
    setIsDataLoading(true);
    axios.post("".concat(Common.baseApiUrl, "getcustomersfromfilters"), {
      company_id: values.company_id,
      user_id: Common.currentUser.id,
      from: moment(values.period[0].$d).format(),
      to: moment(values.period[1].$d).format(),
      keyword: values.candidate_code
    }).then(function (response) {
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  var items = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(PersonPlusFill, {
        size: 24
      }), " NOUVEAU CANDIDAT"]
    }),
    key: 1,
    children: /*#__PURE__*/_jsx("div", {
      className: "white-txt cool-radius",
      style: {
        background: "#EEDEDD"
      }
    })
  }, {
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ClockHistory, {
        size: 24
      }), " HISTORIQUE"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsx(_Fragment, {})
  }];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.post(Common.baseApiUrl + 'getcustomersfromfilters', {
      company_id: "0",
      user_id: Common.currentUser.id,
      from: moment(from).format(),
      to: moment(to).format(),
      keyword: ""
    })]).then(function (response) {
      if (response[0].data.status == 200) {
        setCustomers(response[0].data.customers);
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [newCustomerCreated, dataChanged]);
  useEffect(function () {
    setIsDataLoading(true);
    form.setFieldsValue({
      company_id: 0,
      candidate_code: ""
    });
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([{
          value: 0,
          label: "TOUTES"
        }]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [from, to]);
  return /*#__PURE__*/_jsxs(Container, {
    children: [ContextHolder, /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        lg: 12,
        md: 12,
        children: [/*#__PURE__*/_jsxs(Space.Compact, {
          style: {
            width: '100%'
          },
          children: [/*#__PURE__*/_jsx(Input, {
            size: "large",
            onChange: handleExCodeChange,
            placeholder: "Orienter un dossier existant"
          }), /*#__PURE__*/_jsx(Button, {
            loading: exSearchLoading,
            type: "primary",
            onClick: function onClick() {
              handleGetEx();
            },
            size: "large",
            children: /*#__PURE__*/_jsx("b", {
              children: "RECHERCHE"
            })
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          className: "cool-radius",
          style: {
            background: "#F8F8F8"
          },
          children: /*#__PURE__*/_jsx(Result, {
            title: "Enregistrer un nouveau patient pour encaisser",
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:voice-presentation",
              width: "64",
              height: "64"
            }),
            extra: [/*#__PURE__*/_jsx(Button, {
              size: "large",
              icon: /*#__PURE__*/_jsx(Plus, {}),
              onClick: function onClick() {
                setShowNewCandidate(true);
              },
              type: "primary",
              children: /*#__PURE__*/_jsx("b", {
                children: " Nouveau Patient"
              })
            }, "console"), /*#__PURE__*/_jsx(Button, {
              size: "large",
              icon: /*#__PURE__*/_jsx(ClockHistory, {}),
              onClick: function onClick() {
                setShowHistory(true);
              },
              type: "default",
              children: /*#__PURE__*/_jsx("b", {
                children: " Historique"
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: "Infos patient",
      destroyOnClose: true,
      footer: null,
      open: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      children: /*#__PURE__*/_jsx(PatientView, {
        pid: searchId
      })
    }), currentCustomer != null && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["MODIFICATION DU PATIENT - ", currentCustomer.name]
        }),
        destroyOnClose: true,
        width: "850px",
        footer: null,
        open: showEdit,
        onCancel: function onCancel() {
          setShowEdit(false);
        },
        children: /*#__PURE__*/_jsx(EditCandidate, {
          candidate: currentCustomer,
          handleUpdate: function handleUpdate() {
            setShowEdit(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Opération éffectuée"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsxs("b", {
          children: ["AJOUTER UNE PIECE ID - ", currentCustomer.name]
        }),
        destroyOnClose: true,
        width: "300px",
        footer: null,
        open: showAddFile,
        onCancel: function onCancel() {
          setShowAddFile(false);
        },
        children: /*#__PURE__*/_jsx(AddIdFile, {
          candidat: currentCustomer,
          handler: function handler() {
            setShowAddFile(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Opération éffectuée"
            });
          }
        })
      })]
    }), exCandidate != null && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsxs("b", {
        children: ["ORIENTATION DU PATIENT - ", exCandidate.candidate_code]
      }),
      destroyOnClose: true,
      width: "200px",
      height: "320px",
      placement: "top",
      open: execDrawerVisible,
      headerStyle: {
        background: "#F7F2F2"
      },
      contentStyle: {
        padding: "10px"
      },
      onClose: function onClose() {
        setExecDrawerVisible(false);
      },
      extra: [/*#__PURE__*/_jsx(Button, {
        loading: redirectLoading,
        type: "primary",
        onClick: function onClick() {
          confirm({
            title: /*#__PURE__*/_jsx("b", {
              children: "Confirmez-vous ?"
            }),
            content: /*#__PURE__*/_jsxs("p", {
              children: ["L'orientation du candidat pour un controle de ", exOrientation == 0 && /*#__PURE__*/_jsx("b", {
                children: "Visite annuelle"
              }), " ", exOrientation == 1 && /*#__PURE__*/_jsx("b", {
                children: "pr\xE9-ambauche"
              }), " ?"]
            }),
            onOk: function onOk() {
              setRedirectLoading(true);
              axios.post(Common.baseApiUrl + "redirectcandicate", {
                user_id: Common.currentUser.id,
                candidate_code: exCandidate.candidate_code,
                reason: exOrientation
              }).then(function (response) {
                if (response.data.status == 200) {
                  setExecDrawerVisible(false);
                  notification.success({
                    message: "Ok!",
                    description: response.data.message
                  });
                } else {
                  notification.error({
                    message: "Erreur!",
                    description: response.data.message
                  });
                }
              })["catch"](function (error) {
                notification.error({
                  message: "Erreur!",
                  description: "Une erreur est survenue " + error
                });
              })["finally"](function () {
                setRedirectLoading(false);
              });
            }
          });
        },
        children: /*#__PURE__*/_jsx("b", {
          children: "ORIENTER"
        })
      })],
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 7,
            children: /*#__PURE__*/_jsxs(Descriptions, {
              size: "small",
              bordered: true,
              title: /*#__PURE__*/_jsx("b", {
                children: "INFOS CANDIDAT"
              }),
              column: 1,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "NOM"
                }),
                children: exCandidate.name
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "TELEPHONE"
                }),
                children: exCandidate.mobile_first
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "PROFESSION"
                }),
                children: exCandidate.job
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: /*#__PURE__*/_jsx("b", {
                  children: "SOCIETE"
                }),
                children: /*#__PURE__*/_jsx("b", {
                  children: exCandidate.company.label
                })
              })]
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 5,
            md: 5,
            children: [/*#__PURE__*/_jsx(Radio.Group, {
              block: true,
              options: [{
                label: "VISITE ANNUELLE",
                value: 0
              }, {
                label: "VISITE JOURNALIERS",
                value: 3
              }],
              onChange: function onChange(v) {
                setExOrientation(v.target.value);
              },
              defaultValue: 0,
              optionType: "button",
              buttonStyle: "solid"
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
              children: "Orienter le candidat en cr\xE9ant une nouvelle file d'attente et en archivant le dossier existant"
            }), /*#__PURE__*/_jsx("br", {})]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Nouveau candidat"
      }),
      width: {
        xs: '95%',
        sm: '95%',
        md: '90%',
        lg: '85%',
        xl: '70%',
        xxl: '70%'
      },
      open: showNewCandidate,
      onCancel: function onCancel() {
        setShowNewCandidate(false);
      },
      footer: null,
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(AddCustomer, {
          handleUpdate: handleUpdate
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "Historique candidats"
      }),
      width: {
        xs: '98%',
        sm: '98%',
        md: '95%',
        lg: '90%',
        xl: '80%',
        xxl: '70%'
      },
      open: showHistory,
      onCancel: function onCancel() {
        setShowHistory(false);
      },
      footer: null,
      destroyOnClose: true,
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          minHeight: "430px"
        },
        children: [/*#__PURE__*/_jsx(Popover, {
          placement: "topLeft",
          open: open,
          trigger: "click",
          onOpenChange: handleOpenChange,
          title: "RECHERCHE",
          content: /*#__PURE__*/_jsx(Form, {
            form: form,
            onFinish: onSearchFinish,
            children: /*#__PURE__*/_jsxs(Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "company_id",
                children: /*#__PURE__*/_jsx(Select, {
                  options: compOptions,
                  style: {
                    width: "200px"
                  }
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "period",
                rules: [{
                  required: true,
                  message: "Veuillez choisir une période"
                }],
                children: /*#__PURE__*/_jsx(RangePicker, {})
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "keyword",
                children: /*#__PURE__*/_jsx(Input, {
                  placeholder: "Code dossier/Num\xE9ro mobile"
                })
              }), /*#__PURE__*/_jsxs(Space, {
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    type: "primary",
                    htmlType: "submit",
                    children: /*#__PURE__*/_jsx("b", {
                      children: "CHERCHER"
                    })
                  })
                }), /*#__PURE__*/_jsx(Form.Item, {
                  children: /*#__PURE__*/_jsx(Button, {
                    loading: isDataLoading,
                    type: "link",
                    onClick: function onClick() {
                      setOpen(false);
                    },
                    icon: /*#__PURE__*/_jsx(XLg, {
                      size: 24
                    }),
                    children: " Fermer"
                  })
                })]
              })]
            })
          }),
          children: /*#__PURE__*/_jsx(Button, {
            size: "small",
            children: /*#__PURE__*/_jsx("b", {
              children: /*#__PURE__*/_jsx(ThreeDots, {
                size: 20
              })
            })
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
          striped: true,
          responsive: true,
          bordered: true,
          children: [/*#__PURE__*/_jsx("thead", {
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Date"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Ref"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Matricule"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Categorie"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Nom"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "type"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Societe"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Nat."
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Telephone"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Agent"
                })
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "Action"
                })
              })]
            })
          }), /*#__PURE__*/_jsx("tbody", {
            children: customers.map(function (c) {
              return /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.candidate_code
                }), /*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: c.matricule
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: c.category != "0" && c.category
                }), /*#__PURE__*/_jsx("td", {
                  children: c.name
                }), /*#__PURE__*/_jsxs("td", {
                  children: [c.reason == 0 && /*#__PURE__*/_jsx("span", {
                    children: "VISITE ANNUELLE"
                  }), c.reason == 1 && /*#__PURE__*/_jsx("span", {
                    children: "PRE-AMBAUCHE"
                  }), c.reason == 2 && /*#__PURE__*/_jsx("span", {
                    children: "PERMIS DE TRAVAIL"
                  }), c.reason == 3 && /*#__PURE__*/_jsx("span", {
                    children: "JOURNALIER"
                  })]
                }), /*#__PURE__*/_jsx("td", {
                  children: c.company.label
                }), /*#__PURE__*/_jsx("td", {
                  children: c.nationality
                }), /*#__PURE__*/_jsx("td", {
                  children: c.mobile_first
                }), /*#__PURE__*/_jsx("td", {
                  children: c.user && "".concat(c.user.firstname, " ").concat(c.user.lastname)
                }), /*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsxs(Space, {
                    direction: "horizontal",
                    children: [/*#__PURE__*/_jsx(Button, {
                      type: "link",
                      onClick: function onClick() {
                        setCurrentCustomer(c);
                        setShowEdit(true);
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: /*#__PURE__*/_jsx(PencilFill, {
                          size: 24
                        })
                      })
                    }), /*#__PURE__*/_jsx(Button, {
                      type: "link",
                      onClick: function onClick() {
                        setCurrentCustomer(c);
                        setShowAddFile(true);
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: /*#__PURE__*/_jsx(PersonVcardFill, {
                          size: 24
                        })
                      })
                    })]
                  })
                })]
              }, c.id);
            })
          })]
        })]
      })
    })]
  });
};
export default Cashier;